<template>
  <section class="promo-campaign" role="region" aria-labelledby="promo-title">
    <div class="promo-campaign-banner">
      <div class="promo-campaign-banner__slide" v-for="index in 40" :key="index" aria-hidden="true">
        {{  $t('calculator.promotion-campaign.banner-text') }}
      </div>
    </div>
    <div class="promo-campaign-timer">
      <span id="promo-title" class="promo-campaign-timer__title">
        {{  $t('calculator.promotion-campaign.timer-title') }}
      </span>
      <span class="promo-campaign-timer__value" aria-label="Time remaining" role="timer" aria-live="polite" aria-atomic="true">
        {{ formattedTime }}
      </span>
    </div>
    <div class="promo-campaign-disclaimer">
      {{  $t('calculator.promotion-campaign.disclaimer') }}
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useTimer } from "@kano/composables";

interface PromoInfo {
  code: string;
  expirationDate: Date;
}

const props = defineProps<{
  promoInfo: PromoInfo,
}>();

const promoExpirationDate = computed(() => props.promoInfo.expirationDate ?? null);
const { formattedTime } = useTimer(promoExpirationDate);
</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

@keyframes slideshow {
  100% {
    -webkit-transform: translateX(-200%);
    transform: translateX(-200%);
  }
}

.promo-campaign {
  text-align: center;
  --banner-height: 42px;
  @include breakpoints.desktop {
    --banner-height: 44px;
  }

  &-banner {
    position: absolute;
    left: 0;
    width: 100%;
    padding: 8px 0;
    display: flex;
    flex-direction: row;
    background: #BDF5A3;
    overflow: hidden;

    &__slide {
      font-family: Inter Tight, Inter Tight fallback, sans-serif;
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;

      @include breakpoints.desktop {
        font-size: 20px;
        line-height: 28px;
      }

      padding: 0 16px;
      flex-shrink: 0;
      transform: translate3d(0, 0, 0);
      animation: slideshow 10s linear infinite;
    }
  }

  &-timer {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: calc(16px + var(--banner-height));

    &__title {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    }

    &__value {
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      font-variant-numeric: tabular-nums;

      @include breakpoints.desktop {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }

  &-disclaimer {
    color: #B3B3B3;
    font-size: 14px;
    line-height: 20px;
    margin-top: 32px;
  }
}
</style>